export default "__VITE_ASSET__DhS2Vbm7__"